import { render, staticRenderFns } from "./traceInfo.vue?vue&type=template&id=0f189052&scoped=true&"
import script from "./traceInfo.vue?vue&type=script&lang=js&"
export * from "./traceInfo.vue?vue&type=script&lang=js&"
import style0 from "./traceInfo.vue?vue&type=style&index=0&id=0f189052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f189052",
  null
  
)

export default component.exports